/**
 * Logo-urile partenerilor, validate de client pe 30.10 (`docs/logo-parteneri/`).
 *
 * 🔴 AICI se schimba un logo, si nicaieri altundeva: fisierul sta in `public/parteneri/`. Cu acelasi
 * nume si aceeasi extensie e suficienta suprascrierea lui; cu alta extensie (ex. `.svg`), se schimba
 * si calea de mai jos. `logo-parteneri.test.ts` pica daca o cale nu mai are fisier.
 *
 * Cat timp e pe PNG, logo-ul Carturesti (179×51 px) e la limita pe telefon — asteptam altul de la client.
 */
export const LOGO_PARTENERI = {
    minister: { src: '/parteneri/logo-minister.png', alt: 'Ministerul Mediului, Apelor și Pădurilor' },
    altex: { src: '/parteneri/logo-altex.png', alt: 'Altex' },
    carturesti: { src: '/parteneri/logo-carturesti.png', alt: 'Cărturești' },
} as const;
